import { render, staticRenderFns } from "./Forte.vue?vue&type=template&id=fdfacb20&"
import script from "./Forte.vue?vue&type=script&lang=js&"
export * from "./Forte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports